module.exports = __webpack_public_path__ + "files/629a55a7e793da068dc580d184cc0e31.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-regular.ttf
// module id = 1437
// module chunks = 60